module.exports = __webpack_public_path__ + "static/media/WITH FLAP.d3b2a167.svg";